/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';
import {
  CONDO_INSERT,
  CONDO_INSERT_FAIL,
  CONDO_INSERT_SUCCESS,
  CONDO_SEARCH,
  CONDO_SEARCH_FAIL,
  CONDO_SEARCH_SUCCESS,
  CONDO_SELECT,
  CONDO_SELECT_FAIL,
  CONDO_SELECT_SUCCESS,
  CONDO_UPDATE,
  CONDO_UPDATE_FAIL,
  CONDO_UPDATE_SUCCESS,
} from '../constants/ActionTypes';

// Condo names search by where clause (subdivision name and value)
export const searchCondo = searchCriteria => async dispatch => {
  dispatch({ type: CONDO_SEARCH });
  try {
    const condoSearchResults = await apiService.Condo.searchCondoName(searchCriteria);
    dispatch({
      type: CONDO_SEARCH_SUCCESS,
      payload: { condoSearchResults },
    });
  } catch (err) {
    console.error('Error: Condo searchCondo', err);
    dispatch({ type: CONDO_SEARCH_FAIL });
  }
};

// Select a condo name by UniqueID
// NOTE: this behavior is not used in legacy app
export const selectCondo = UniqueID => async dispatch => {
  dispatch({ type: CONDO_SELECT });
  try {
    const condoSelected = await apiService.Condo.selectCondoName(UniqueID);
    dispatch({
      type: CONDO_SELECT_SUCCESS,
      payload: { condoSelected },
    });
  } catch (err) {
    console.error('Error: Condo selectCondo', err);
    dispatch({ type: CONDO_SELECT_FAIL });
  }
};

// Creates new condo name record and returns new condo name record
export const createCondo = newCondoRecord => async dispatch => {
  dispatch({ type: CONDO_INSERT });
  try {
    const condoCreated = await apiService.Condo.createCondoName(newCondoRecord); // returns UniqueID
    const newCondo = {
      UniqueID: condoCreated.UniqueID,
      CondoName: newCondoRecord.CondoData.CondoName,
      SubdivisionName: newCondoRecord.CondoData.SubdivisionName,
    };

    dispatch({
      type: CONDO_INSERT_SUCCESS,
      payload: { newCondo },
    });
  } catch (err) {
    console.error('Error: Condo createCondo', err);
    dispatch({ type: CONDO_INSERT_FAIL });
  }
};

// Edit/update the condo name of an existing condo record
export const updateCondo = condoRecord => async dispatch => {
  dispatch({ type: CONDO_UPDATE });
  try {
    const updatedCondo = await apiService.Condo.updateCondoName(condoRecord); // returns type SUCCESS or FAILURE (name already exists)
    dispatch({
      type: CONDO_UPDATE_SUCCESS,
      payload: { updateStatus: updatedCondo },
    });
  } catch (err) {
    console.error('Error: Condo updateCondo', err);
    dispatch({ type: CONDO_UPDATE_FAIL });
  }
};
